/**
 * DetailsPanel Component
 * Displays detailed information about a selected person including
 * biography, connections, and associated items
 */

import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";


export default function DetailsPanel({ person, onClose, personToItems }) {
  return (
    <AnimatePresence>
      {person && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          className="mt-6 w-full rounded-2xl border bg-white shadow p-4"
          data-testid="details-panel"
        >
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="text-lg font-semibold">
                {person.name_jp}{" "}
                <span className="text-gray-500">/ {person.name_romaji}</span>
              </div>
              <div className="text-xs text-gray-600">
                {person.years || "?"} ・ {person.region || ""}
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-gray-100"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          {person.description && (
            <p className="mt-3 text-sm leading-relaxed text-gray-800">
              {person.description}
            </p>
          )}

          {person.connections && person.connections.length > 0 && (
            <div className="mt-3">
              <div className="text-xs font-medium mb-1">Connections</div>
              <div className="flex flex-wrap gap-2">
                {person.connections.map((c, i) => (
                  <span
                    key={i}
                    className="text-xs bg-gray-100 border rounded-full px-2 py-1"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>
          )}
          {(!person.connections || person.connections.length === 0) && (
            <div className="mt-3">
              <div className="text-xs font-medium mb-1">Connections</div>
              <div className="text-xs text-gray-500">—</div>
            </div>
          )}

          <div className="mt-3">
            <div className="text-xs font-medium mb-1">Items linked</div>
            <div className="flex flex-wrap gap-2">
              {(person.items && person.items.length > 0
                ? person.items
                : personToItems[person.name_jp] || []
              ).map((it, i) => (
                <span
                  key={i}
                  className="text-xs bg-amber-50 border border-amber-200 rounded-full px-2 py-1"
                >
                  {it}
                </span>
              ))}
              {(!person.items || person.items.length === 0) &&
                !personToItems[person.name_jp] && (
                  <span className="text-xs text-gray-500">—</span>
                )}
            </div>
          </div>

          <div className="mt-4 text-xs text-gray-500">
            Tip: Use search or adjust year range to focus the timeline, then
            click another bar to compare.
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}